import { render } from "./usersMenu.vue?vue&type=template&id=723618a7"
import script from "./usersMenu.vue?vue&type=script&lang=js"
export * from "./usersMenu.vue?vue&type=script&lang=js"

import "./usersMenu.vue?vue&type=style&index=0&id=723618a7&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__